import type * as core from '../../../../../core'

export const PACKAGE = {
  contents: [
    // Uses some common data structures (e.g. address)
    'package:data.universal.commonStructures',
    'resource:data.dimensions.externalInstitutions.attributes.address',
    'resource:data.dimensions.externalInstitutions.attributes.ein',
    'resource:data.dimensions.externalInstitutions.attributes.samName',
    'resource:data.dimensions.externalInstitutions.attributes.uei',
    'resource:data.dimensions.externalInstitutions.entities.institution.attributes.type',
    'resource:data.dimensions.externalInstitutions.entities.institution',
    'resource:data.dimensions.externalInstitutions',
    'resource:data.enums.institutionType.entries.forProfitOther',
    'resource:data.enums.institutionType.entries.forProfitSmallBiz',
    'resource:data.enums.institutionType.entries.foreign',
    'resource:data.enums.institutionType.entries.govtCounty',
    'resource:data.enums.institutionType.entries.govtIsd',
    'resource:data.enums.institutionType.entries.govtMunicipal',
    'resource:data.enums.institutionType.entries.govtPih',
    'resource:data.enums.institutionType.entries.govtSpecialDistrict',
    'resource:data.enums.institutionType.entries.govtTerritory',
    'resource:data.enums.institutionType.entries.higherEdHbcu',
    'resource:data.enums.institutionType.entries.higherEdPrivate',
    'resource:data.enums.institutionType.entries.higherEdPublic',
    'resource:data.enums.institutionType.entries.higherEdTccu',
    'resource:data.enums.institutionType.entries.individual',
    'resource:data.enums.institutionType.entries.intlRegional',
    'resource:data.enums.institutionType.entries.nativeTribalDesignee',
    'resource:data.enums.institutionType.entries.nativeTribalFederal',
    'resource:data.enums.institutionType.entries.nativeTribalOther',
    'resource:data.enums.institutionType.entries.nonProfit501c3',
    'resource:data.enums.institutionType.entries.nonProfitOther',
    'resource:data.enums.institutionType.entries.other',
    'resource:data.enums.institutionType.entries.servingHispanic',
    'resource:data.enums.institutionType.entries.servingNativeAlaskaHawaii',
    'resource:data.enums.institutionType',
  ],
  description: 'TODO',
  name: 'Data - External Institutions',
} as const satisfies core.quiver.Package
